"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var runtype_1 = require("../runtype");

function Intersect() {
  var intersectees = [];

  for (var _i = 0; _i < arguments.length; _i++) {
    intersectees[_i] = arguments[_i];
  }

  return runtype_1.create(function (value) {
    for (var _i = 0, intersectees_1 = intersectees; _i < intersectees_1.length; _i++) {
      var validate = intersectees_1[_i].validate;
      var validated = validate(value);

      if (!validated.success) {
        return validated;
      }
    }

    return {
      success: true,
      value: value
    };
  }, {
    tag: 'intersect',
    intersectees: intersectees
  });
}

exports.Intersect = Intersect;